import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class SafeSportService {
  private _apiEvent = '/api/Event';
  private _apiTeam = '/api/team';
  private _apiAssociation = '/api/association';
  private _apiOrgAdmin = "/api/orgadmin";
  private _apiClubProgram = "/api/ClubProgram";

  constructor(private _http: HttpService, private _httpClient: HttpClient) { }

  getAllSendGridEmail() {
    return this._http.get(
      this._apiEvent + `/get-all-safe-sport-document-types`
    );
  }

  getSafeSportCertificatesByUserID(userID: number) {
    return this._http.get(this._apiTeam + '/get-safe-sport-certificates-by-userID/' + userID);
  }

  getCurrentOrgSeasonListByOrgID(orgID: number) {
    return this._http.get(this._apiAssociation + '/get-current-org-season-list-by-org-id/' + orgID);
  }

  removeSafeSportDocument(obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        PlayerFormIDList: obj.PlayerFormIDs,
      }
    };
    return this._httpClient.delete(this._apiTeam + '/remove-safe-sport-document', httpOptions);
  }

  //get-org-safe-sport-player-list-by-clubID
  getOrgSafeSportPlayerListByClubID(clubID: number) {
    return this._http.get(this._apiAssociation + '/get-org-safe-sport-player-list-by-clubID/' + clubID);
  }

  getClubPlayersSorList(clubID: number, orgSeasonGroupID: number) {
    return this._http.get(this._apiClubProgram + '/get-club-players-sor-list/' + clubID + '/' + orgSeasonGroupID);
  }

  getClubPlayersSafeSportList(clubID: number, orgSeasonGroupID: number) {
    return this._http.get(this._apiClubProgram + '/get-club-players-safesport-list/' + clubID + '/' + orgSeasonGroupID);
  }

  savePlayerSorStatus(payload: any) {
    return this._http.post(this._apiClubProgram + '/save-player-sor-status', payload);
  }

  //[HttpGet("get-club-staff-safesport-list/{clubID}")]
  getClubStaffSafeSportList(clubID: number, orgseasonID: number) {
    return this._http.get(this._apiClubProgram + '/get-club-staff-safesport-list/' + clubID + '/' + orgseasonID);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/safesport.service.ts